import i18n from '@/i18n'

export const roleOptions = [
  {
    name: i18n.t('teamModal.coowner'),
    value: 'co-owner'
  },
  {
    name: i18n.t('teamModal.admin'),
    value: 'admin'
  },
  {
    name: i18n.t('teamModal.contributor'),
    value: 'contributor'
  },
  {
    name: i18n.t('teamModal.viewer'),
    value: 'viewer'
  },
  {
    name: i18n.t('teamModal.anonAdmin'),
    value: 'anonAdmin'
  },
  {
    name: i18n.t('teamModal.anonContributor'),
    value: 'anonContributor'
  },
  {
    name: i18n.t('teamModal.anonViewer'),
    value: 'anonViewer'
  },
  {
    name: i18n.t('teamModal.anonCoordinator'),
    value: 'anonCoordinator'
  },
  {
    name: i18n.t('teamModal.resultsViewer'),
    value: 'resultsViewer'
  }
]

export const roleOptionsOhio = [
  {
    name: i18n.t('teamModal.teammate'),
    value: 'teammate',
    show: true
  },
  {
    name: i18n.t('teamModal.teacher'),
    value: 'teacher',
    show: true
  },
  {
    name: i18n.t('teamModal.mentor'),
    value: 'mentor',
    show: true
  },
  {
    name: i18n.t('teamModal.jacDirector'),
    value: 'JAC Director',
    show: false
  }
]

export default {
  data: function () {
    return {
      roleOptions, roleOptionsOhio
    }
  },
  computed: {
    roleOptionsNames () {
      return roleOptions.map(role => role.name)
    },
    roleOptionsValues () {
      return roleOptions.map(role => role.value)
    },
    roleOptionsNamesOhio () {
      return roleOptionsOhio.map(role => role.name)
    },
    roleOptionsValuesOhio () {
      return roleOptionsOhio.map(role => role.value)
    },
    allRoleOptions () {
      return [this.roleOptions, this.roleOptionsOhio].flat()
    }
  }
}
